import React, { Component } from 'react';
import { connect } from 'react-redux';
import { RESET_STATUS_STATE, SET_ERROR_STATE } from '../../../utils/constants/actionTypes';
import { SetForgotPass } from '../../../redux/actions/ForgotPass';

import Label from '../../../components/atoms/Label';
import TextBox from '../../../components/atoms/TextBox';
import Button from '../../../components/atoms/Button';


class ResetPassword extends Component {
    constructor (props) {
		super(props);

		this.state = {
            otp : '',
            pass : '',
            repass : ''
        }
    }

    changeValueState = ({name, value}) => {
        this.setState({
            [name] : value
        })
    }

    prosesResendVer = () => {
        const {SetError, ActionSetForgotPass} = this.props;
        const {otp, pass, repass} = this.state;
        const {email, id} = this.props.match.params;


        //Check field
        (pass === '' || repass === '' || otp === '') ? SetError('Semua field harus diisi.') : 
        (pass !== repass) ? SetError('Kata Sandi Baru dan Konfirmasi Kata Sandi Baru tidak sesuai.') :
        ActionSetForgotPass({ id, email, password : pass, verificationToken : otp });

    }

    componentDidMount = () => {
        this.props.ResetError();
    }

    render () {
        const {otp, pass, repass} = this.state;
        const {loading, error, success, successMsg} = this.props.status;
        

        return (
            <div className='container'>
                <div className='box-forgot d-flex flex-column align-items-center'>
                    <img src='/img/icon/forgot-password.png' alt='' />

                    <Label type='title' className='label-kc-mb mt-3 mb-3' value='Atur Ulang Kata Sandi' />
                    <Label type='paragraph' className='mb-5' value='Masukkan kata sandi baru dan Kode OTP yang telah dikirimkan bersama surel permintaan atur ulang kata sandi.' />
                    
                    {error  &&
                        <div className='alert alert-kc alert-danger'>
                            <strong>Error!</strong> {error}
                        </div>
                    }

                    {success  &&
                        <div className='alert alert-kc alert-success'>
                            <strong>Berhasil!</strong> {successMsg}
                        </div>
                    }
                    
                    <div className='form-group'>
                        <Label type='paragraph' className='label-kc-s' value='Masukkan kode OTP' />
                        <TextBox name='otp' className='mt-2' value={otp} onChange={e => this.changeValueState(e.target)} type='text' />
                    </div>

                    <div className='form-group'>
                        <Label type='paragraph' className='label-kc-s' value='Kata Sandi Baru' />
                        <TextBox name='pass' className='mt-2' value={pass} onChange={e => this.changeValueState(e.target)} type='password' />
                    </div>

                    <div className='form-group'>
                        <Label type='paragraph' className='label-kc-s' value='Konfirmasi Kata Sandi Baru' />
                        <TextBox name='repass' className='mt-2' value={repass} onChange={e => this.changeValueState(e.target)} type='password' />
                    </div>
                    
                    <Button type='submit' title='KIRIM' loading={loading} onClick={this.prosesResendVer} color='blue' width='block'/>

                    <div className='d-flex justify-content-center align-items-center mt-3'>
                        <Label type='paragraph' value='Kembali ke halaman login, ' />
                        <Label type='paragraph' className='blue ml-1 link' onClick={() => { this.props.history.push('/login') }} value='Klik di Sini' />
                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = state => {
	return {
		status: state.statusState
	}
}

const mapDispatchToProps = dispatch => {
    return {
        ResetError : () => {
            dispatch({type : RESET_STATUS_STATE})
        },
		SetError: (msgErr) => {
			dispatch({ type: SET_ERROR_STATE, payload: msgErr })
		},
		ActionSetForgotPass: (data) => {
			dispatch(SetForgotPass(data))
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
